if (!customElements.get('op-moco-selector')) {
    class OpMocoSelector extends HTMLElement {
        connectedCallback() {
            this.sectionId = this.dataset.sectionId;
            this.sectionRoot = document.getElementById(`shopify-section-${this.sectionId}`) || this;
            this.mocos = [...this.sectionRoot.querySelectorAll('.js-moco-element')];
            this.currentMoco = this.mocos.find(moco => moco.classList.contains('js-selected-moco')) || null;
            this.hoverImages = [...this.sectionRoot.querySelectorAll('.js-hover-galley-img')];
            if (!this.hoverImages.length) {
                this.hoverImages = [...document.querySelectorAll('.js-hover-galley-img')];
            }
            this.mainGalleryImg = this.sectionRoot.querySelector(".js-media-img img") || document.querySelector(".js-media-img img");
            this.hoverTimer = null;
            this.productDom = {
                price: document.querySelector(`#op-main-price-${this.sectionId}`),
                compareAtPrice: document.querySelector(`#op-main-compare-${this.sectionId}`),
                frame: document.querySelector(`#js-frame-info-${this.sectionId} .subtitle`),
                lens: document.querySelector(`#js-lens-info-${this.sectionId} .subtitle`),
            }

            this.compareWrappers = document.querySelectorAll(`.js-compare-wrapper-${this.sectionId}`);
            this.promoBadges = document.querySelectorAll(`.js-promoBadge-${this.sectionId}`);

            Object.keys(this.productDom).forEach(key => {
                if (this.productDom[key]) this.productDom[key].classList.add('tw-transition');
            });

            this.mocos.filter(moco => !moco.classList.contains('js-selected-moco')).forEach(moco => {
                moco.addEventListener('mouseenter', (evt) => {
                    this.highlightMoco(evt, moco);
                });

                moco.addEventListener('mouseleave', (evt) => {
                    this.highlightMoco(evt, this.currentMoco);
                });
            });

            this.onDkCodesChanged = () => {
                if (this.currentMoco) this.applyPriceFromNode(this.currentMoco);
            };
            document.addEventListener('po:dk:discount-codes-changed', this.onDkCodesChanged);
        }

        disconnectedCallback() {
            if (this.onDkCodesChanged) {
                document.removeEventListener('po:dk:discount-codes-changed', this.onDkCodesChanged);
            }
        }


        highlightMoco = (evt, element) => {
            if (!element) return;

            const isMouseLeave = evt?.type === "mouseleave";

            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                if (isMouseLeave) this.hoverTimer = null;
            }

            if (!isMouseLeave && element === this.currentMoco) return;

            this.reduceElementsOpacity(true);
            
            this.hoverTimer = setTimeout(() => {
                this.updateDom(element);
                this.reduceElementsOpacity(false);
            }, 300);
        }

        applyPriceFromNode = (element) => {
            const resolved = window.PoDkStorefrontPrices?.resolveDisplayFromNode?.(element);
            const priceText = resolved?.priceText ?? element.dataset.price ?? '';
            const compareText = resolved?.compareText ?? element.dataset.compare ?? '';
            const promoBadge = resolved?.promoBadge ?? element.dataset.promoBadge?.trim() ?? '';
            const hasDiscount = resolved?.hasDiscount ?? Boolean(element.dataset.compare);

            if (this.productDom.price) this.productDom.price.textContent = priceText;
            if (this.productDom.compareAtPrice) {
                this.productDom.compareAtPrice.textContent = compareText;
            }
            this.compareWrappers.forEach((el) => el.classList.toggle('tw-hidden', !hasDiscount));
            this.promoBadges.forEach((el) => {
                el.textContent = promoBadge;
            });
        };

        updateDom = (element) => {
            if (!element) return;

            this.hoverImages.forEach(img => img.classList.remove('tw-opacity-100'));

            const mocoData = {
                lens: element.dataset.lens,
                frame: element.dataset.frame,
                srcset: element.dataset.srcset || null
            };

            const hoverImage = this.hoverImages.find(
                (img) => img.dataset.productHandle === element.dataset.handle
            );
            const priceNode =
                hoverImage?.dataset?.poDkBaseCents != null ? hoverImage : element;

            this.applyPriceFromNode(priceNode);
            if (this.productDom.lens) this.productDom.lens.textContent = mocoData.lens;
            if (this.productDom.frame) this.productDom.frame.textContent = mocoData.frame;

            if (mocoData.srcset && this.mainGalleryImg) {
                this.mainGalleryImg.setAttribute('srcset', mocoData.srcset);
                this.mainGalleryImg.setAttribute('src', mocoData.srcset);
            }

            if (hoverImage) hoverImage.classList.add('tw-opacity-100');
        }

        reduceElementsOpacity(boolean) {
            Object.keys(this.productDom).forEach(key => {
                if (this.productDom[key]) this.productDom[key].classList.toggle('tw-opacity-50', boolean);
            });
        }
    }
    customElements.define("op-moco-selector", OpMocoSelector);
}
